import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
  "/_auth/admin/processes/$id/versions/$versionId",
)({
  params: {
    parse(params) {
      return z
        .object({
          id: z.coerce.number(),
          versionId: z.string(), // Allow string to handle both numbers and "new"
        })
        .parse(params);
    },
  },
});
